



























































import Vue, { PropType } from "vue";

// Model
import { getInstallationPredictedStatusIconColor } from "@/utility/Constants";
import { InstallationPredictedStatusEnum, installationPredictedStatusEnumLabel } from "@/model/data/predictiveMaintenance/InstallationPredictedStatusEnum";
import { GetDevicesPredictedStatusReqData } from "@/model/communication/predictiveMaintenance/FetchInstallationsPredictedStatusCommand";

export default Vue.extend({
    props: {
        filteredTotalsByStatus: {
            required: true,
        },
        totalsByStatus: {
            required: true,
            type: Map as PropType<Map<InstallationPredictedStatusEnum, number>>,
        },
        loading: {
            required: true,
            type: Boolean,
        },
        reqData: {
            type: Object as () => GetDevicesPredictedStatusReqData,
        },
    },
    data() {
        return {
            ordering: { 0: 1, 1: 3, 2: 2 },
            firstTime: true,
        };
    },
    computed: {
        colsAttribute(): number {
            if (this.totalsByStatus.length % 3 == 0) return 4;
            return 6;
        },
    },
    watch: {
        loading(newValue) {
            if (!newValue) this.firstTime = false;
        },
    },
    methods: {
        getInstallationPredictedStatusIconColor,
        installationPredictedStatusEnumLabel,

        toggleFilter(predictedStatus: InstallationPredictedStatusEnum) {
            let newReqData = { ...this.reqData };
            newReqData.offset = 0;

            if (this.reqData.predictedStatusFilter != null) {
                if (this.reqData.predictedStatusFilter.includes(predictedStatus)) {
                    newReqData.predictedStatusFilter = this.reqData.predictedStatusFilter.filter((v) => v != predictedStatus);
                    if (newReqData.predictedStatusFilter.length == 0) newReqData.predictedStatusFilter = null;
                } else newReqData.predictedStatusFilter.push(predictedStatus);
            } else {
                newReqData.predictedStatusFilter = [];
                newReqData.predictedStatusFilter.push(predictedStatus);
            }
            this.$emit("send-request", newReqData);
        },
    },
});
